import ParcelexApi from '@/services/parcelex';
import isMobile from '@/lib/isMobile';

export default {
  options({ device, apiKey, user, order, sessionId, trackId, hasGracePeriod, pxToken }) {
    const { shipping, products } = order;
    const deviceIsApp = device === 'app';
    const deviceToSend = (device || (isMobile() ? 'mobile' : 'desktop')) === 'desktop'
      ? 'desktop' : 'mobile';
    const apiData = {
      apiKey,
      device: deviceIsApp ? 'app' : deviceToSend,
      sessionId,
      // user
      phone: user.phone,
      cpf: user.cpf,
      email: user.email,
      // shipping
      shipping: shipping.value,
      zipCode: shipping.zipCode,
      addressStreet: shipping.street,
      addressNumber: shipping.number,
      addressComplement: shipping.complement,
      city: shipping.city,
      state: shipping.state,
      source: 'checkout',
      trackId,
      hasGracePeriod,
    };
    // product
    const product = products[0];
    apiData.products = products;
    apiData.productAmount = product.amount;
    apiData.productPrice = product.value;

    apiData.skuNumber = product.id;
    apiData.productName = product.name;
    apiData.productDescription = product.description;
    apiData.productImage = product.image;
    apiData.productUrl = product.url;
    apiData.categoryName = product.category;
    apiData.categoryId = product.categoryId;
    apiData.seller = product.seller;

    const baseUrl = '/public/options';
    const url = pxToken ? `${baseUrl}?pxToken=${pxToken}` : baseUrl;
    return ParcelexApi.post(url, apiData);
  },
  preview(data) {
    return ParcelexApi.post('/public/preview', data);
  },
  updateShipping({ shipping, checkoutId, apiKey }) {
    const apiData = {
      checkoutId,
      shipping: shipping.value,
      zipCode: shipping.zipCode,
      addressStreet: shipping.street,
      addressNumber: shipping.number,
      addressComplement: shipping.complement,
      apiKey,
    };
    return ParcelexApi.post('/public/checkout/updateShipping', apiData);
  },
  sendConfirmationCode({
    cpf,
    isSecurityCode,
    resend,
    method,
    apiKey,
  }) {
    const lowerCaseMethod = method.toLowerCase();
    const apiData = {
      cpf,
      isSecurityCode,
      resend,
      attribute: lowerCaseMethod === 'sms' || lowerCaseMethod === 'whatsapp' ? 'phone' : 'email',
      apiKey,
    };
    return ParcelexApi.post(`user/send/${lowerCaseMethod}`, apiData);
  },
  confirmSecurityCode({
    cpf,
    token,
    apiKey,
  }) {
    const apiData = {
      cpf,
      token,
      apiKey,
    };
    return ParcelexApi.post('user/check/auth', apiData);
  },
  createUser({
    cpf,
    email,
    phone,
    zipCode,
    apiKey,
  }) {
    const apiData = {
      cpf,
      email,
      phone,
      zipCode,
    };
    return ParcelexApi.post('user/create', apiData, { headers: { 'x-parcelex-apikey': apiKey } });
  },
};
